import { Alert, Box, Grid } from "@mui/material";
import CustomAutocomplete from "./CustomAutocomplete";
import { useAppDispatch, useAppSelector } from "../../../hooks";
import { Site } from "../../../redux/slices/sitesSlice";
import { Client } from "../../../redux/slices/clientsSlice";
import {
  setClient,
  setSiteExpedition,
  setSiteVente,
} from "../slices/preOrderFilterSlice";
import { useCallback } from "react";
import { useTranslation } from "react-i18next";

const PreOrderFilter = () => {
  const dispatch = useAppDispatch();
  const { t } = useTranslation();

  // Sites affectés au représentant par l'administration (et non plus la totalité des sites Sage).
  const {
    sitesVente,
    sitesExpedition,
    loaded: sitesLoaded,
    loading: sitesLoading,
  } = useAppSelector((state) => state.mySitesSlice);

  const { clients, loading: clientsLoading } = useAppSelector(
    (state) => state.clientsSlice
  );

  const { client, siteExpedition, siteVente } = useAppSelector(
    (state) => state.preOrderFilterSlice
  );

  const processClients = () => clients || [];

  const getSitesLabel = (option: Site) => `${option.Code} - ${option.Libelle}`;
  const getClientsLabel = (option: Client) =>
    `${option.NumeroClient} - ${option.RaisonSociale}`;

  const getSitesKey = (option: Site) => option.Code;
  const getClientsKey = (option: Client) => option.NumeroClient;

  const defaultSiteVente = sitesVente[0];
  const defaultSiteExpedition = sitesExpedition[0];
  const defaultClient = clients?.[0];

  const noSitesAssigned =
    sitesLoaded &&
    !sitesLoading &&
    (sitesVente.length === 0 || sitesExpedition.length === 0);

  const handleChangeSiteVente = useCallback(
    (newValue: Site) => {
      dispatch(setSiteVente(newValue));
    },
    [dispatch]
  );

  const handleChangeSiteExpedition = useCallback(
    (newValue: Site) => {
      dispatch(setSiteExpedition(newValue));
    },
    [dispatch]
  );

  const handleChangeClient = useCallback(
    (newValue: Client) => {
      dispatch(setClient(newValue));
    },
    [dispatch]
  );

  return (
    <Box
      p={2}
      sx={{
        border: "1px solid #E8EBFD",
        borderRadius: "5px",
      }}
    >
      {noSitesAssigned && (
        <Alert severity="warning" sx={{ mb: 2 }}>
          {t("newPreOrder.noSitesAssigned")}
        </Alert>
      )}
      <Grid
        container
        columnSpacing={3}
        sx={{
          display: "flex",
          flexDirection: "row",
          justifyContent: "space-between",
        }}
      >
        <Grid item xs={12} md={4}>
          <CustomAutocomplete
            id="salesSites"
            loading={sitesLoading}
            label={t("newPreOrder.labels.salesSite")}
            options={sitesVente}
            getOptionLabel={getSitesLabel}
            getOptionKey={getSitesKey}
            defaultValue={defaultSiteVente}
            value={siteVente}
            onChange={handleChangeSiteVente}
          />
        </Grid>
        <Grid item xs={12} md={4}>
          <CustomAutocomplete
            id="clients"
            loading={clientsLoading}
            label={t("newPreOrder.labels.client")}
            options={processClients()}
            getOptionLabel={getClientsLabel}
            getOptionKey={getClientsKey}
            defaultValue={defaultClient}
            value={client}
            onChange={handleChangeClient}
          />
        </Grid>
        <Grid item xs={12} md={4}>
          <CustomAutocomplete
            id="expSites"
            loading={sitesLoading}
            label={t("newPreOrder.labels.expSite")}
            options={sitesExpedition}
            getOptionLabel={getSitesLabel}
            getOptionKey={getSitesKey}
            defaultValue={defaultSiteExpedition}
            value={siteExpedition}
            onChange={handleChangeSiteExpedition}
          />
        </Grid>
      </Grid>
    </Box>
  );
};

export default PreOrderFilter;
